/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPlanTemplateIdFullParams,
  GetPlanTemplateLibraryParams,
  PatchPlanTemplateIdParams,
  PostPlanTemplateIdPromoteToLibraryParams,
  PostPlanTemplateParams,
  TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest,
  TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest,
  TrainWithMeModulesPlansDtosResponsesPlanTemplateFullResponse,
  TrainWithMeModulesPlansDtosResponsesPlanTemplateListItem
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postPlanTemplate = (
    trainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest?: BodyType<TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest>,
    params?: PostPlanTemplateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPlansDtosResponsesPlanTemplateFullResponse>(
      {url: `/plan-template`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest,
        params, signal
    },
      options);
    }




export const getPostPlanTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanTemplate>>, TError,{data?: BodyType<TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest>;params?: PostPlanTemplateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanTemplate>>, TError,{data?: BodyType<TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest>;params?: PostPlanTemplateParams}, TContext> => {

const mutationKey = ['postPlanTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanTemplate>>, {data?: BodyType<TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest>;params?: PostPlanTemplateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postPlanTemplate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanTemplate>>>
    export type PostPlanTemplateMutationBody = BodyType<TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest> | undefined
    export type PostPlanTemplateMutationError = ErrorType<unknown>

    export const usePostPlanTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanTemplate>>, TError,{data?: BodyType<TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest>;params?: PostPlanTemplateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanTemplate>>,
        TError,
        {data?: BodyType<TrainWithMeModulesPlansDtosRequestsPostPlanTemplateRequest>;params?: PostPlanTemplateParams},
        TContext
      > => {
      return useMutation(getPostPlanTemplateMutationOptions(options), queryClient);
    }
    export const getPlanTemplateLibrary = (
    params?: GetPlanTemplateLibraryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPlansDtosResponsesPlanTemplateListItem[]>(
      {url: `/plan-template/library`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanTemplateLibraryQueryKey = (params?: GetPlanTemplateLibraryParams,) => {
    return [
    `/plan-template/library`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanTemplateLibraryQueryOptions = <TData = Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError = ErrorType<unknown>>(params?: GetPlanTemplateLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanTemplateLibraryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanTemplateLibrary>>> = ({ signal }) => getPlanTemplateLibrary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanTemplateLibraryQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanTemplateLibrary>>>
export type GetPlanTemplateLibraryQueryError = ErrorType<unknown>


export function useGetPlanTemplateLibrary<TData = Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPlanTemplateLibraryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanTemplateLibrary>>,
          TError,
          Awaited<ReturnType<typeof getPlanTemplateLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanTemplateLibrary<TData = Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError = ErrorType<unknown>>(
 params?: GetPlanTemplateLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanTemplateLibrary>>,
          TError,
          Awaited<ReturnType<typeof getPlanTemplateLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanTemplateLibrary<TData = Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError = ErrorType<unknown>>(
 params?: GetPlanTemplateLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanTemplateLibrary<TData = Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError = ErrorType<unknown>>(
 params?: GetPlanTemplateLibraryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateLibrary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanTemplateLibraryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deletePlanTemplateId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/plan-template/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePlanTemplateIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlanTemplateId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlanTemplateId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePlanTemplateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlanTemplateId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePlanTemplateId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlanTemplateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlanTemplateId>>>

    export type DeletePlanTemplateIdMutationError = ErrorType<unknown>

    export const useDeletePlanTemplateId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlanTemplateId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePlanTemplateId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePlanTemplateIdMutationOptions(options), queryClient);
    }
    export const patchPlanTemplateId = (
    id: number,
    trainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest?: BodyType<TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest>,
    params?: PatchPlanTemplateIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPlansDtosResponsesPlanTemplateFullResponse>(
      {url: `/plan-template/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest,
        params, signal
    },
      options);
    }




export const getPatchPlanTemplateIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPlanTemplateId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest>;params?: PatchPlanTemplateIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPlanTemplateId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest>;params?: PatchPlanTemplateIdParams}, TContext> => {

const mutationKey = ['patchPlanTemplateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPlanTemplateId>>, {id: number;data?: BodyType<TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest>;params?: PatchPlanTemplateIdParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  patchPlanTemplateId(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchPlanTemplateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchPlanTemplateId>>>
    export type PatchPlanTemplateIdMutationBody = BodyType<TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest> | undefined
    export type PatchPlanTemplateIdMutationError = ErrorType<unknown>

    export const usePatchPlanTemplateId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPlanTemplateId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest>;params?: PatchPlanTemplateIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPlanTemplateId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesPlansDtosRequestsPatchPlanTemplateRequest>;params?: PatchPlanTemplateIdParams},
        TContext
      > => {
      return useMutation(getPatchPlanTemplateIdMutationOptions(options), queryClient);
    }
    export const getPlanTemplateIdFull = (
    id: number,
    params?: GetPlanTemplateIdFullParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPlansDtosResponsesPlanTemplateFullResponse>(
      {url: `/plan-template/${id}/full`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanTemplateIdFullQueryKey = (id: number,
    params?: GetPlanTemplateIdFullParams,) => {
    return [
    `/plan-template/${id}/full`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanTemplateIdFullQueryOptions = <TData = Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError = ErrorType<unknown>>(id: number,
    params?: GetPlanTemplateIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanTemplateIdFullQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanTemplateIdFull>>> = ({ signal }) => getPlanTemplateIdFull(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanTemplateIdFullQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanTemplateIdFull>>>
export type GetPlanTemplateIdFullQueryError = ErrorType<unknown>


export function useGetPlanTemplateIdFull<TData = Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetPlanTemplateIdFullParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanTemplateIdFull>>,
          TError,
          Awaited<ReturnType<typeof getPlanTemplateIdFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanTemplateIdFull<TData = Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanTemplateIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanTemplateIdFull>>,
          TError,
          Awaited<ReturnType<typeof getPlanTemplateIdFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanTemplateIdFull<TData = Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanTemplateIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanTemplateIdFull<TData = Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanTemplateIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanTemplateIdFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanTemplateIdFullQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPlanTemplateIdPromoteToLibrary = (
    id: number,
    params?: PostPlanTemplateIdPromoteToLibraryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPlansDtosResponsesPlanTemplateFullResponse>(
      {url: `/plan-template/${id}/promote-to-library`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostPlanTemplateIdPromoteToLibraryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanTemplateIdPromoteToLibrary>>, TError,{id: number;params?: PostPlanTemplateIdPromoteToLibraryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanTemplateIdPromoteToLibrary>>, TError,{id: number;params?: PostPlanTemplateIdPromoteToLibraryParams}, TContext> => {

const mutationKey = ['postPlanTemplateIdPromoteToLibrary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanTemplateIdPromoteToLibrary>>, {id: number;params?: PostPlanTemplateIdPromoteToLibraryParams}> = (props) => {
          const {id,params} = props ?? {};

          return  postPlanTemplateIdPromoteToLibrary(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanTemplateIdPromoteToLibraryMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanTemplateIdPromoteToLibrary>>>

    export type PostPlanTemplateIdPromoteToLibraryMutationError = ErrorType<unknown>

    export const usePostPlanTemplateIdPromoteToLibrary = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanTemplateIdPromoteToLibrary>>, TError,{id: number;params?: PostPlanTemplateIdPromoteToLibraryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanTemplateIdPromoteToLibrary>>,
        TError,
        {id: number;params?: PostPlanTemplateIdPromoteToLibraryParams},
        TContext
      > => {
      return useMutation(getPostPlanTemplateIdPromoteToLibraryMutationOptions(options), queryClient);
    }
